// requestHandler.ts
import "rxjs";
import "./metaDataStore";
import "./protocol";
var PassthroughHandler = class {
  constructor(upstream) {
    this.upstream = upstream;
    this.destroyed = false;
  }
  subscription(op, payload) {
    return this.upstream.subscription(op, payload);
  }
  async query(op, payload) {
    return this.upstream.query(op, payload);
  }
  async mutation(op, payload) {
    return this.upstream.mutation(op, payload);
  }
  destroy() {
    if (this.destroyed)
      throw new Error("Destroying already destroyed RequestHandler!");
    this.destroyed = true;
    this.upstream.destroy();
  }
  stop(payload) {
    this.upstream.stop(payload);
  }
};
export {
  PassthroughHandler
};
